module.exports = __webpack_public_path__ + "img/lens-logo-icon.feb6375a.png";